<div class="form-group mb-3 row">
  @if (!omitLabel) {
    <span class="col-xl-5 col-form-label {{omitVerticalPadding ? 'pt-0 pb-0' : ''}} pe-0">
      @if (label) {
        <label>{{ label }}</label>
      } @else {
        <ng-content select="label"></ng-content>
        <ng-content select=".formGroupLabel"></ng-content>
      }
    </span>
  }
  <div class="col-xl">
    <ng-content></ng-content>
  </div>
</div>

